import { Col, Pagination, Row, Typography } from 'antd';
import { PaginationProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import CollapsableFilter from '../../../../shared/components/collapsable-filter/collapsable-filter';
import FormActions from '../../../../shared/components/form-actions/form-actions';
import PageTitle from '../../../../shared/components/page-title/page-title';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import useFormWithSearchParams from '../../../../shared/hooks/use-form-with-search-params';
import ClientGroupsFilterForm from './client-groups-filter-form/client-groups-filter-form';
import { clientGroupsFilterFormId } from '../../constants/constants';
import { ClientGroupsFilterFormModel } from '../../models/client-groups-filter-form-model';

interface Props {
  pagination?: PaginationProps;
}
const ClientGroupsHeader = ({ pagination }: Props): JSX.Element => {
  const screens = useBreakpoint();
  const { t } = useTranslation('common');
  const form = useFormWithSearchParams<ClientGroupsFilterFormModel>();

  return (
    <>
      {screens.sm ? (
        <>
          <PageTitle>{t('label.groups')}</PageTitle>
          <ClientGroupsFilterForm form={form} />
          <Row justify="space-between">
            <Col className="paginationPadding" flex="auto">
              <FormActions form={form} formId={clientGroupsFilterFormId} />
            </Col>
            <Col className="paginationPadding">
              <Pagination {...pagination} />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <CollapsableFilter header={<Typography.Text strong>{t('label.filters')}</Typography.Text>} keyProp="1">
            <ClientGroupsFilterForm form={form} />
            <FormActions form={form} formId={clientGroupsFilterFormId} />
          </CollapsableFilter>
          <div className="paginationPadding">
            <Pagination {...pagination} />
          </div>
        </>
      )}
    </>
  );
};
export default ClientGroupsHeader;
